/**
 * Los links de una nota interna: se pintan clickeables, y el de un presupuesto se puede mandar al
 * cliente con un botón desde la misma nota, sin copiarlo al compose.
 */
import { LINK_MARKETPLACE_HASH } from "@/services/XCONS_ENV";
import type { TimelineRow } from "@/services/conversations.api";

const URL_RE = /https?:\/\/[^\s<>()]+/g;

/** Un link sin la puntuación con la que termina la oración («…/uid/abc.»). */
function limpiar(url: string): string {
  return url.replace(/[.,;:!?»"')\]]+$/, "");
}

export type TrozoDeNota = { tipo: "texto"; texto: string } | { tipo: "link"; url: string };

/** El texto partido en texto y links, en orden; lo que queda después de un link sigue como texto. */
export function partirLinks(texto: string): TrozoDeNota[] {
  const trozos: TrozoDeNota[] = [];
  let ultimo = 0;
  for (const m of texto.matchAll(URL_RE)) {
    const url = limpiar(m[0]);
    if (m.index! > ultimo) trozos.push({ tipo: "texto", texto: texto.slice(ultimo, m.index) });
    trozos.push({ tipo: "link", url });
    ultimo = m.index! + url.length;
  }
  if (ultimo < texto.length) trozos.push({ tipo: "texto", texto: texto.slice(ultimo) });
  return trozos;
}

/** El primer link de presupuesto de la nota, o `null`. */
export function linkDePresupuesto(texto: string): string | null {
  for (const t of partirLinks(texto)) if (t.tipo === "link" && t.url.includes(LINK_MARKETPLACE_HASH)) return t.url;
  return null;
}

/** ¿Ya salió un mensaje al cliente con ese link? Entonces el botón muestra que se mandó. */
export function linkYaEnviado(rows: TimelineRow[], link: string): boolean {
  return rows.some((r) => r.kind === "message" && r.payload.senderType === "operator" && !!r.payload.content?.includes(link));
}
